import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { utils, comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import {
    APIS,
    SF_BIDR_USR_INFO,
    SG_BIDR_USR_CTGR_LIST,
    URLS,
} from "@/tra/tancis/ptli/usr/bidrusr/services/PtliBidrUsrService";
import { values } from "lodash";

/*
 * Bidder Approval Request Details
 * !== 공매자 승인 요청 상세 ==!
 */
export const PTLI0911002S = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { openPopup } = usePopup();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0011" },
            { area: "comnCd", comnCd: "COM0052" },
            { area: "comnCd", comnCd: "COM0021" },
            { area: "comnCd", comnCd: "PTL0001" },
            { area: "cstmCd" },
            { area: "cntyCd" },
        ],
    });
    const [usrTp, setUsrTp] = useState("E");
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // User Information !== 사용자(대표자) 정보 ==!
        bidrUsrInfo: useForm({
            defaultSchema: SF_BIDR_USR_INFO,
        }),
    };

    const grid = {
        bidrUsrCtgrList: useGrid({ defaultSchema: SG_BIDR_USR_CTGR_LIST }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Create Bidder User Information !== 공매 사용자 정보 등록 ==!
        createOrgUsrInfo: useFetch({
            api: (data: any) => APIS.createBidrUsrInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(`${URLS.ptli0911001q}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
        getTinNoLst: useFetch({
            api: () => {
                return APIS.getPayerTinNoLst(xtrnUsrIdntfNo, "A");
            },
            // enabled: !!coTin,
            // key: [coTin],
            onSuccess: (data) => {
                const tinNoList = data.tinNoList.content;

                if (tinNoList.length == 1) {
                    const tinNoInfo = tinNoList[0];
                    form.bidrUsrInfo.setValue("xtrnUsrIdntfNo", tinNoInfo.tinNo);
                    form.bidrUsrInfo.setValue("usrNm", tinNoInfo.coNm);
                    form.bidrUsrInfo.setValue("usrMoblNo", tinNoInfo.rprsTelno);
                    form.bidrUsrInfo.setValue("rsdtAddr", tinNoInfo.coAddr);
                    form.bidrUsrInfo.setValue("usrEmlAddr", tinNoInfo.rprsEml);
                    handler.checkUsrTin();
                } else {
                    toast.showToast({ type: "error", content: "msg.clr.00004" });
                }
            },
        }),
        // User Tin duplicate check !== 사용자 TIN 중복 체크 ==!
        getBidrDuplCheck: useFetch({
            api: (data: any) => APIS.getBidrDuplCheck(data),
            enabled: false,
            onSuccess: (data) => {
                form.bidrUsrInfo.clearErrors("xtrnUsrIdntfNo");

                const bidrUsrInfoContent = data.bidrUsrInfo.content;

                if (!comnUtils.isEmpty(bidrUsrInfoContent)) {
                    if (bidrUsrInfoContent.bidrYn === "Y") {
                        form.bidrUsrInfo.setError("xtrnUsrIdntfNo", {
                            message: "msg.com.00107", // Already registered user. !== 이미 등록된 사용자입니다. ==!
                            type: "error",
                        });

                        form.bidrUsrInfo.setValue("usrNm", null);
                        form.bidrUsrInfo.setValue("frgnrYn", null);
                        form.bidrUsrInfo.setValue("aplcCntyCd", null);
                        form.bidrUsrInfo.setValue("usrMoblNo", null);
                        form.bidrUsrInfo.setValue("rsdtAddr", null);
                        form.bidrUsrInfo.setValue("usrEmlAddr", null);

                        form.bidrUsrInfo.setValue("xtrnUsrRgsrYn", "N");
                    } else {
                        form.bidrUsrInfo.setValue("usrNm", bidrUsrInfoContent.usrNm);
                        form.bidrUsrInfo.setValue("frgnrYn", bidrUsrInfoContent.frgnrYn);
                        form.bidrUsrInfo.setValue("aplcCntyCd", bidrUsrInfoContent.aplcCntyCd);
                        form.bidrUsrInfo.setValue("usrMoblNo", bidrUsrInfoContent.usrMoblNo);
                        form.bidrUsrInfo.setValue("usrEmlAddr", bidrUsrInfoContent.usrEmlAddr);
                        form.bidrUsrInfo.setValue("rsdtAddr", bidrUsrInfoContent.rsdtAddr);

                        form.bidrUsrInfo.setValue("xtrnUsrRgsrYn", "Y");
                    }
                } else {
                    form.bidrUsrInfo.setValue("xtrnUsrRgsrYn", "N");
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {};

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        onBidrSaveBtnClick: () => {
            if (
                comnUtils.isEmpty(form.bidrUsrInfo.getValue("cstmOfcrNo")) &&
                form.bidrUsrInfo.getValue("actnCtgrCd") == "1"
            ) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            if (!comnUtils.isEmpty(form.bidrUsrInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            const arrBidrUsrCtgr = grid.bidrUsrCtgrList.getData();
            const arrRow: String[] = [];

            // Check for duplicate Code !== 중복 코드 검사 ==!
            arrBidrUsrCtgr.forEach((objPrmt) => {
                if (!comnUtils.isEmpty(objPrmt.actnCtgrCd)) {
                    arrRow.push(objPrmt.actnCtgrCd);
                }
            });

            const setRow = new Set(arrRow);
            if (setRow.size < arrRow.length) {
                toast.showToast({ type: "warning", content: "msg.00005" }); // Duplicate data exists.., !== 중복된 데이터가 존재합니다.. ==!
                return;
            }

            // save Information of Organization !== 기관 정보 저장 ==!
            form.bidrUsrInfo.handleSubmit(
                () => {
                    const data = form.bidrUsrInfo.getValues();
                    const bidrUsrCtgrList = grid.bidrUsrCtgrList.getData();

                    data.bidrUsrCtgrList = bidrUsrCtgrList;

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.createOrgUsrInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },

        onBtnGrdDelRowClick: () => {
            if (comnUtils.isEmpty(grid.bidrUsrCtgrList.getChecked())) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    grid.bidrUsrCtgrList.deleteRow("checkbox");
                },
            });
        },

        // checkDcltTin: () => {
        //     const dcltTin = form.bidrUsrInfo.getValue("xtrnUsrIdntfNo");
        //     if (dcltTin) {
        //     } else {
        //         form.bidrUsrInfo.clearErrors("xtrnUsrIdntfNo");
        //     }
        // },

        setCoTinChange: () => {
            const dcltTin = form.bidrUsrInfo.getValue("xtrnUsrIdntfNo");
            form.bidrUsrInfo.setError("xtrnUsrIdntfNo", {
                message: "msg.ptl.00755", // Please check your TIN. !== TIN을 조회해주세요. ==!
                type: "error",
            });
        },

        usrTpChange: () => {
            const usrTp = form.bidrUsrInfo.getValue("usrTp");
            if (comnUtils.isEmpty(usrTp)) {
                setUsrTp("E");
            } else {
                setUsrTp(usrTp);
            }
        },

        checkUsrTin: () => {
            const xtrnUsrIdntfNo = form.bidrUsrInfo.getValue("xtrnUsrIdntfNo");
            if (xtrnUsrIdntfNo) {
                fetch.getBidrDuplCheck.fetch(xtrnUsrIdntfNo);
            } else {
                form.bidrUsrInfo.clearErrors("xtrnUsrIdntfNo");
            }
        },
    };

    useEffect(() => {}, []);

    const xtrnUsrIdntfNo = form.bidrUsrInfo.watch("xtrnUsrIdntfNo");
    return (
        <Page>
            <form>
                <Group>
                    <Group.Header>
                        <Group.Title title={t("T_USR_INFO")} />
                    </Group.Header>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    {...form.bidrUsrInfo.schema.xtrnUsrIdntfNo}
                                    rightButton={{
                                        icon: "search",
                                        onClick: () => {
                                            fetch.getTinNoLst.fetch(xtrnUsrIdntfNo);
                                        },
                                    }}
                                />
                                <Group.Control {...form.bidrUsrInfo.schema.usrNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bidrUsrInfo.schema.usrStatCd}></Group.Control>
                                <Group.Control {...form.bidrUsrInfo.schema.frgnrYn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.bidrUsrInfo.schema.usrTp}
                                    onChange={handler.usrTpChange}
                                ></Group.Control>
                                <Group.Control {...form.bidrUsrInfo.schema.cstmOfcrNo} required={usrTp == "I"} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bidrUsrInfo.schema.aplcCntyCd}></Group.Control>
                                <Group.Control {...form.bidrUsrInfo.schema.usrMoblNo}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bidrUsrInfo.schema.usrEmlAddr}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bidrUsrInfo.schema.rsdtAddr}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
                <Group>
                    <Group.Body>
                        <Group.Section gap={2}>
                            <Layout.Right>
                                <Button
                                    role="gridAdd"
                                    onClick={() => {
                                        grid.bidrUsrCtgrList.addRow();
                                    }}
                                ></Button>
                                <Button role={"gridDelete"} onClick={handler.onBtnGrdDelRowClick} />
                            </Layout.Right>
                            <Grid
                                {...grid.bidrUsrCtgrList.grid}
                                // data={fetch.getCstmUsrAuthList.data?.bidrUsrCtgrList}
                            />
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0911001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onBidrSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
